import axios from "../axios";
import { savePendingRegistration, clearPendingRegistration } from "../../../helper/pendingRegistration";
const ID_TOKEN_KEY = "token";
// Clé de helper/OnGoingClassManage.js (cours en cours mémorisé dans le navigateur)
const CLASS_DETAILS_KEY = "onClassDetails";
// Jeton de connexion utilisable : jamais « undefined » ni « null » (avant, l'inscription par
// e-mail enregistrait « undefined » : le site se croyait connecté)
const isToken = (token) => typeof token === "string" && token.trim() !== "" && token !== "undefined" && token !== "null";
const auth = {
  emailRegistration(data,lang) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/register/${lang}`, data)
        .then((response) => {
          // Google ou Facebook : connecté tout de suite ; e-mail : en attente du code
          if (response?.data?.token) this.saveToken(response.data.token);
          else if (response?.data?.registration_token)
            savePendingRegistration({ id: response.data.user?._id, registration_token: response.data.registration_token, email: response.data.user?.email });
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },

  verifyOTP(data) {
    return new Promise((resolve, reject) => {
      axios
        .post("/verify", data)
        .then((response) => {
          this.saveToken(response?.data?.token);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },

  setPassword(data,lang) {
    return new Promise((resolve, reject) => {
      
      axios
        .post(`/set-password/${lang}`, data)
        .then((response) => {
          this.saveToken(response?.data?.token);
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },

  login(data) {
    return new Promise((resolve, reject) => {
      axios
        .post("/login", data)
        .then((response) => {
          resolve(response);
          this.saveToken(response?.data?.token);
        })
        .catch((error) => reject(error));
    });
  },

  // 🔒 Tour 69 (A3) : « Se déconnecter de tous les appareils », celui-ci compris
  logoutAll() {
    return axios.post("/logout-all").then(({ data }) => {
      this.destroyToken("dis");
      return data;
    });
  },
  // 🔒 Tour 69 (A3) : code pour fermer un compte sans mot de passe (Google, Facebook), envoyé par e-mail
  sendCloseCode() {
    return axios.post("/account/close-code").then(({ data }) => data);
  },

  logout() {
    return new Promise((resolve, reject) => {
      
      axios
        .post("/logout")
        .then(({ data }) => {
          this.destroyToken("dis");

          resolve(data);
        })
        .catch(({ response }) => {
          this.destroyToken("dis");
          reject(response);
        });
    });
  },
  // 🔑 Mot de passe oublié (tour 66, A8) : jeton retiré sans recharger la page. Avant, destroyToken() renvoyait vers
  // /login après chaque réponse : le message « Si un compte existe… » (ou l'erreur) disparaissait aussitôt
  forgetPassword(data) {
    return new Promise((resolve, reject) => {

      axios
        .post("/forgot-password", data)
        .then(({ data }) => {
          this.destroyToken("dis");

          resolve(data);
        })
        .catch(({ response }) => {
          this.destroyToken("dis");
          reject(response);
        });
    });
  },
  resetPassword(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .post("/password-reset", data)
        .then(({ data }) => {
          this.destroyToken();

          resolve(data);
        })
        .catch(({ response }) => {
          this.destroyToken();
          reject(response);
        });
    });
  },
  // ✍️ « C'est correct » du bandeau de vérification du prénom et du nom
  confirmNameCheck() {
    return axios.post("/name-check/confirm").then(({ data }) => data);
  },
  getAuthUserData() {
    return new Promise((resolve, reject) => {
      
      axios
        .get("/get-auth-user")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          response?.status === 401 && this?.destroyToken();
          reject(response);
        });
    });
  },
  getNotification() {
    return new Promise((resolve, reject) => {
      
      axios
        .get("get-notification")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  cleartNotification() {
    return new Promise((resolve, reject) => {
      
      axios
        .delete("delete-notification")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  getSupportData() {
    return new Promise((resolve, reject) => {
      
      axios
        .get("/get-support-messages")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  GptChatBot(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .post("/GptChat",data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  // 🤖 Questions proposées à l'ouverture de l'assistant (les 4 premières de l'admin)
  assistantSuggestions() {
    return axios.get("/assistant/suggestions").then(({ data }) => data?.data || []);
  },
  getSupportDataById(id) {
    return new Promise((resolve, reject) => {
      
      axios
        .get(`/get-support-messages/${id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  sendQueryEmail(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .post(`/send-support-email`, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  // ✉️ Lettre d'information : accord depuis le compte ({ newsletter })
  getNewsletter() {
    return axios.query("/newsletter").then(({ data }) => data);
  },
  setNewsletter(newsletter) {
    return axios.put("/newsletter", { newsletter }).then(({ data }) => data);
  },
  setLanguage(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .post(`/users/change-lang`, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  // Lien signé reçu par e-mail : signature envoyée avec l'identifiant
  unsubscrbeEmail(id, signature) {
    return new Promise((resolve, reject) => {
      
      axios
        .post(`unsubscribe-email/${id}`, { signature })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  popupStatus() {
    return new Promise((resolve, reject) => {
      
      axios
        .post(`/popup-status`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  getToken() {
    const token = window.localStorage.getItem(ID_TOKEN_KEY);
    return isToken(token) ? token : null;
  },
  // Au démarrage du site : un jeton inutilisable déjà enregistré (« undefined ») est retiré
  cleanInvalidToken() {
    const token = window.localStorage.getItem(ID_TOKEN_KEY);
    if (token !== null && !isToken(token)) window.localStorage.removeItem(ID_TOKEN_KEY);
  },
  // 📧 Inscription en attente du code : nouveau code, ou annulation (jeton d'inscription)
  resendRegistrationCode(registrationToken) {
    return axios.post("/registration/resend-code", { registration_token: registrationToken }).then(({ data }) => data);
  },
  cancelRegistration(registrationToken) {
    return axios.post("/registration/cancel", { registration_token: registrationToken }).then(({ data }) => data);
  },
  saveToken(token) {
    if (!isToken(token)) return;
    window.localStorage.setItem(ID_TOKEN_KEY, token);
    clearPendingRegistration();
    // Nouvelle session : le cours mémorisé (bouton « Retour au cours ») venait peut-être d'un autre compte
    window.localStorage.removeItem(CLASS_DETAILS_KEY);
  },
  destroyToken(distory) {
    window.localStorage.removeItem(CLASS_DETAILS_KEY);
    if (distory) {
      window.localStorage.removeItem(ID_TOKEN_KEY);
    } else {
      window.localStorage.removeItem(ID_TOKEN_KEY);
      window.location.href = "/login";
    }
  },
};

export default auth;
